import React, { Fragment, useState, useReducer, useEffect } from 'react';
import SideBar from './SideBar';
import NavHader from './NavHader';
import Header from './Header';
import { fetchLogos } from '../../../services/AuthService';

const initialState = {
  active: '',
  activeMenu: '',
  activeSubmenu: ''
};

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState
});

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [state, setState] = useReducer(reducer, initialState);
  const [toggle, setToggle] = useState('');
  
  // Fetch org data (logos, jobTitleLabel) when admin layout mounts (login + refresh)
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetails?.user?.organizationId) {
      fetchLogos();
    }
  }, []);

  // Set initial state based on screen width
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    // Check if window exists (for SSR compatibility)
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      console.log('Device width on init:', width);
      // Return true if screen width is less than or equal to 1024px
      const shouldCollapse = width <= 1024;
      console.log('Should sidebar be collapsed?', shouldCollapse);
      return shouldCollapse;
    }
    return false;
  });
  
  // Add effect to handle responsive sidebar and initialize state
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      console.log('Window resized to:', width);
      // Collapse sidebar on tablet and mobile (screen width <= 1024px)
      if (width <= 1024) {
        console.log('Collapsing sidebar for mobile/tablet');
        setIsSidebarCollapsed(true);
        const mainWrapper = document.querySelector('#main-wrapper');
        if (mainWrapper) {
          console.log('Adding menu-toggle class');
          mainWrapper.classList.add('menu-toggle');
        }
      } else {
        console.log('Expanding sidebar for desktop');
        setIsSidebarCollapsed(false);
        const mainWrapper = document.querySelector('#main-wrapper');
        if (mainWrapper) {
          console.log('Removing menu-toggle class');
          mainWrapper.classList.remove('menu-toggle');
        }
      }
    };

    // Initial setup
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    console.log('Sidebar collapsed state changed:', isSidebarCollapsed);
    console.log('Main wrapper classes:', document.querySelector('#main-wrapper')?.classList.toString());
  }, [isSidebarCollapsed]);

  useEffect(() => {
    const mainWrapper = document.querySelector('#main-wrapper');
    console.log('Current CSS classes on main-wrapper:', mainWrapper?.classList.toString());
    console.log('Current window width:', window.innerWidth);
    console.log('menu-toggle class present:', mainWrapper?.classList.contains('menu-toggle'));
  }, []);

  const onClick = (name) => setToggle(toggle === name ? '' : name);

  const handleActive = (status, subMenu = '') => {
    if (state.active !== status) {
      setState({ active: status, activeMenu: subMenu });
    } else {
      if (state.activeMenu !== subMenu) {
        setState({ active: status, activeMenu: subMenu });
      }
    }
  };

  const toggleSidebar = () => {
    console.log("Parent toggleSidebar called");
    const mainWrapper = document.querySelector('#main-wrapper');
    console.log("mainWrapper exists:", !!mainWrapper);
    
    if (mainWrapper) {
      console.log("Current isSidebarCollapsed:", isSidebarCollapsed);
      mainWrapper.classList.toggle('menu-toggle');
      setIsSidebarCollapsed(!isSidebarCollapsed);
      console.log("isSidebarCollapsed after update:", !isSidebarCollapsed);
    }
  };

  const closeSidebar = () => {
    const mainWrapper = document.querySelector('#main-wrapper');
    if (mainWrapper) {
      mainWrapper.classList.remove('menu-toggle');
      setIsSidebarCollapsed(false);
    }
  };

  console.log('Window width on load:', window.innerWidth);
  console.log('Initial isSidebarCollapsed state:', isSidebarCollapsed);

  return (
    <Fragment>
      {console.log("Rendering JobieNav with isSidebarCollapsed:", isSidebarCollapsed)}
      {/* <NavHader handleActive={handleActive} /> */}
      <Header
        onNote={() => onClick('chatbox')}
        onNotification={() => onClick('notification')}
        onProfile={() => onClick('profile')}
        toggle={toggle}
        title={title}
        onBox={() => onClick('box')}
        onClick={() => ClickToAddEvent()}
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      />
      {console.log("Passing setIsSidebarCollapsed to SideBar:", !!setIsSidebarCollapsed)}
      <SideBar
        state={state}
        setState={setState}
        handleActive={handleActive}
        closeSidebar={closeSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />
    </Fragment>
  );
};

export default JobieNav;
